module.exports = __webpack_public_path__ + "media/images/illustrations/enrichment-programme-2-95d6c6216dcc09d2b7dc8c58d82d2458.svg";